import Vue from 'vue';
import Icon from '../components/Icon.vue';
import Table from '../components/table/index.vue';
import FilterColumn from '../components/table/FilterColumn.vue';
import Pagination from '../components/Pagination.vue';
import Drawer from '../components/Drawer.vue';
import Title from '../components/Title.vue';
import Organization from '../components/filter/Organization.vue';
import Customer from '../components/filter/Customer.vue';
import Date from '../components/filter/Date.vue';
import Search from '../components/filter/Search.vue';

// 存放组件的数组
const components = [Icon, Table, FilterColumn, Pagination, Drawer, Title, Organization, Customer, Date, Search];

// 遍历 components 数组，来进行全局注册
components.map(component => {
  Vue.component(component.name, component);
});
